import Vue from "vue";
import VueRouter from "vue-router";
import { routes } from "./routes.js";
import auth from "../auth";
import pushDataLayer from "../helpers/dataLayer";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.onError((error) => {
  if (/Loading chunk \d+ failed/.test(error.message)) {
    window.location.reload();
  }
});

router.beforeEach((to, from, next) => {
  if (
    to.matched.some((record) => record.meta?.requiresAuth) &&
    !auth.isLoggedIn()
  ) {
    auth.logout();
    next({ path: "/", query: { returnUrl: to.fullPath } });
  } else {
    document.title = to.meta.title;
    next();
  }
});

//Pageview virtual de cada rota para o GTM (Boards 4388): a SPA não recarrega a página.
//Vai o padrão da rota (/adicionar-acidente-pessoal/:id/...), não os valores: há rotas com data
//de nascimento no caminho e token na query. Da query, só os parâmetros de campanha.
const PARAMETROS_CAMPANHA = /^(utm_\w+|gclid|gbraid|wbraid|fbclid)$/;

router.afterEach((to) => {
  const rota = to.matched.length ? to.matched[to.matched.length - 1].path : to.path;
  const pagePath = rota.replace(/\([^)]*\)/g, "") || "/";
  const campanha = Object.keys(to.query)
    .filter((chave) => PARAMETROS_CAMPANHA.test(chave))
    .map((chave) => `${encodeURIComponent(chave)}=${encodeURIComponent(to.query[chave])}`)
    .join("&");

  pushDataLayer({
    event: "page_view",
    page_path: pagePath,
    page_location: window.location.origin + pagePath + (campanha ? `?${campanha}` : ""),
    page_title: to.meta.title || document.title,
  });
});

export default router;
